import { useState } from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { updateUserInfoMeta, userBonusInfoState } from '@/state/userInfo';
import { userDropdownMobileOpenState } from '@/state/globalSettings';
import uiState from '@/state/ui';
import useTheme from '@/theme/useTheme';
import useUserLoginLogout from '@/hooks/biz/useUserLoginLogout';
import useBindEmailOrLogin from '@/hooks/useBindEmailOrLogin';
import busEvents from '@/helper/busEvents';

export const useUserDropdown = () => {
  const { t } = useTranslation('rewards');
  const { theme } = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // 状态管理
  const { isLogin } = useBindEmailOrLogin();
  const { logout } = useUserLoginLogout();
  const [userInfoData] = useAtom(updateUserInfoMeta);
  const { userMetaData } = userInfoData;
  const { rewards: { playerPendingClaimRewards } } = useAtomValue(userBonusInfoState);
  const { isHeaderTransparent } = useAtomValue(uiState);
  
  // 本地状态
  const [signOutModal, setSignOutModal] = useState(false);
  const [drawerOpen, setDrawerOpenState] = useAtom(userDropdownMobileOpenState);

  // 计算属性
  const iconColor = theme.palette.text.primary;
  const container = typeof window !== 'undefined' ? window?.document?.body : undefined;

  // 事件处理函数
  const handleDrawerClose = () => {
    setDrawerOpenState(false);
  };

  const handleLogout = () => {
    if (isMobile) {
      setDrawerOpenState(false);
    }
    logout();
  };

  const handleLiveSupport = () => {
    busEvents.emit('toggleZendeskStatus');
  };

  const openSignOutModal = () => {
    setSignOutModal(true);
  };

  const closeSignOutModal = () => {
    setSignOutModal(false);
  };

  return {
    // 状态
    isLogin,
    isMobile,
    userMetaData,
    playerPendingClaimRewards,
    signOutModal,
    drawerOpen,
    
    // 计算属性
    iconColor,
    container,
    theme,
    t,
    
    // 事件处理函数
    handleDrawerClose,
    handleLogout,
    handleLiveSupport,
    openSignOutModal,
    closeSignOutModal,
    setDrawerOpenState,
  };
}; 